import { Enquiry } from '@javascript/types/Enquiry';
import classNames from 'classnames';
import { useState } from 'react';
import request from 'superagent';

type WorldpayUnreachableProps = {
  authenticityToken: string;
  enquiry: object;
  prepareEnquiry: (enquiry: Enquiry) => object;
  redirectToErrorPage: () => void;
  stockReference: string;
};

const WorldpayUnreachable = ({
  authenticityToken,
  enquiry,
  prepareEnquiry,
  stockReference,
  redirectToErrorPage,
}: WorldpayUnreachableProps): JSX.Element => {
  const [loading, setLoading] = useState(false);

  const sendEnquiry = (enquiry: object) => {
    setLoading(true);
    request
      .post(`/contact-us/vehicle-enquiry/create-reservation/${stockReference}`)
      .send({
        authenticity_token: authenticityToken,
        reserve_now: true,
        enquiry: prepareEnquiry(enquiry as Enquiry),
      })
      .then((response) => {
        setLoading(false);
        if (response.ok) {
          window.location.href = `/contact-us/thank-you/deal-builder?stock_reference=${stockReference}`;
        }
      })
      .catch((err) => {
        if (window.newrelic) {
          window.newrelic.noticeError(err);
        }
        return redirectToErrorPage();
      });
  };

  return (
    <div className="db-modal__content ac-animation--fade-in-from-right">
      <section className="db-section">
        <p className="db-question">Something went wrong</p>
        <p>
          Sorry, we were unable to reach our payment provider to take your
          reservation deposit. You can send us your enquiry without reserving
          and a member of our team will be in touch to help.
        </p>
      </section>
      <section className="db-section db-section--cta">
        <button
          className={classNames('ch-btn ch-btn--block ch-btn--primary', {
            'ac-btn--loading': loading,
          })}
          onClick={() => sendEnquiry(enquiry)}
          type="button"
        >
          Send your enquiry
        </button>
      </section>
    </div>
  );
};

export default WorldpayUnreachable;
